/* eslint-disable */

// See <stylelab-backend>/buildspec.yml (the AWS CodeBuild config file)
// to see where these environment variables get changed up!
//
// Examples:
//
//          (AWS parameter store key)                   (value)
//
//   /Seer/Development/Frontend/VUE_APP_API_ROOT --> https://dev-api.helloseer.com
//   /Seer/Production/Frontend/VUE_APP_API_ROOT --> https://api.helloseer.com
//   /Seer/Staging/Frontend/VUE_APP_API_ROOT --> https://stage-api.helloseer.com
//

const pkg = require('../package.json');
/*
if (typeof env === 'undefined') {
  var env = {};
}
*/

export const API_ROOT = process.env.VUE_APP_API_ROOT || env.VUE_APP_API_ROOT || 'https://dev-api.helloseer.com'
export const GOOGLE_CLIENT_ID = process.env.VUE_APP_GOOGLE_CLIENT_ID || env.VUE_APP_GOOGLE_CLIENT_ID || '1017899677641-bac58q0kkpf1ru555qkpnkcc67886vsi.apps.googleusercontent.com'
export const SVG2GIF_API = process.env.VUE_APP_SVG2GIF_API || 'https://pdf.helloseer.com/gif'
export const REMOVEBG_API = process.env.VUE_APP_REMOVEBG_API || 'https://bgremove.helloseer.com/url'
export const CookieDomain = (process.env.NODE_ENV === 'production')
  ? '.helloseer.com'
  : ''

export const BUILD_VERSION = pkg.version;

// default SENTRY_DSN taken from... http://sentry.helloseer.com/settings/seer/projects/seer-frontend/keys/
export const SENTRY_DSN = process.env.SENTRY_DSN || 'http://3f65d3b2386a47608239e93614d2b44e@sentry.helloseer.com:9000/4'
export const USE_SENTRY = process.env.USE_SENTRY || false;

export const DEBOUNCE_DEFAULT_TIMEOUT = 200;


// history? 2019 https://github.com/hello-seer/stylelab-backend/commit/0e738eb10a
export const DEFAULT_PRODUCT_IMAGE_WIDTH = 225
export const DEFAULT_PRODUCT_IMAGE_HEIGHT = 337

export const FACET_NAME_GENDER_MATCHES = "GENDER";
export const MATCHES_GENDER_WOMEN = "WOMENSWEAR";
export const MATCHES_GENDER_MEN = "MENSWEAR";

